import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { GetUsersValue, GetUsersValueDto, UserDto, UserLookup, Users } from '../models';
import { IdNameDto } from '@app/store/shared/models';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models';

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getUsers(value: GetUsersValue): Observable<Users> {
        const params = new GetUsersValueDto(value).toHttpParams();

        return this.httpClient.get<ApiResponse<UserDto[]>>('v1/admin/users', { params }).pipe(mapDto((response) => new Users(response)));
    }

    getUsersLookup(): Observable<UserLookup[]> {
        return this.httpClient
            .get<ApiResponse<IdNameDto[]>>('v1/admin/users/lookup')
            .pipe(mapDto((response) => response.data.map((dto) => new UserLookup(dto))));
    }
}
